import './google-maps.css'
import React from 'react';
import GoogleMapReact from 'google-map-react';


 
export default function SimpleMap (props) {
  // console.log(props);
  let location;
  if (props.clinic && props.clinic.location){
    location = JSON.parse(props.clinic.location); 
  }
  
  const zoom = 15;
  
  const renderMarkers = (map, maps) => {
    let marker = new maps.Marker({
    position: { lat: location.lat, lng: location.lng },
    map,
    title: props.clinic.name
    });
    addClickListener(maps, map, marker)
    return marker;
   };

   const addClickListener = (maps, map, marker) => {
    let infowindow = new maps.InfoWindow();
    let content = 'Name: ' + props.clinic.name + '<br/>Lat: ' + location.lat + '<br/>Long: ' + location.lng ;
    marker.addListener('click', ()=>{     
      infowindow.setContent(content);  
      infowindow.open(map, marker); 
    });
   }
 
  if (location) {
    return (
      // Important! Always set the container height explicitly
      <div className='col-sm' style={{ height: '30vh', width: '100%' }}>
          <GoogleMapReact
            className='redBorder'
            bootstrapURLKeys={{ key: "AIzaSyBKMzsTYEHrnlFQurwvYP2DCV0AJtM4GCY" }}
            defaultCenter={location}
            defaultZoom={zoom}
            onGoogleApiLoaded={({ map, maps }) => renderMarkers(map, maps)}
            yesIWantToUseGoogleMapApiInternals={true} 
          >
          </GoogleMapReact>
      </div>
    );
  } else {
    return <h1>No location available</h1>
  }

}